import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { BsCacheService } from '@brightside-web/desktop/data-access/core-services';
import { Intercom } from '@supy-io/ngx-intercom';
import { BsChatService } from '@brightside-web/desktop/data-access/core-services';
import { SharedDesktopModule } from '@brightside-web/shared/desktop';
import { BrightsideUiModule } from '@brightside/brightside-ui';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { SurveyQuestionnaireService } from '../survey-questionnaire.service';

@Component({
    selector: 'brightside-web-survey-completed',
    templateUrl: './survey-completed.component.html',
    styleUrls: ['./survey-completed.component.scss'],
    imports: [CommonModule, SharedDesktopModule, BrightsideUiModule, TranslateModule]
})
export class SurveyCompletedComponent {

  private _surveyQuestionnaireService = inject(SurveyQuestionnaireService);

  constructor(
    private _router: Router,
    private _bsChatService: BsChatService,
    private _bsCacheService: BsCacheService
  ) {}

  async handleSurveyCompleted() {
    const openChatAfterSurvey = await this._bsCacheService.getItem('openChatAfterSurvey');
    if (openChatAfterSurvey) {
      this._bsChatService.showChat();
      this._bsCacheService.removeItem('openChatAfterSurvey');
    }
    this._surveyQuestionnaireService.backToHomeCalled();
  }
}
